import { useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { WaitlistForm } from "./WaitlistForm";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PhysicalInterest = ({ source = "homepage", compact = false, yesLabel = "Ja, hätte ich gerne" }) => {
  const [choice, setChoice] = useState(null);

  const vote = (c) => {
    setChoice(c);
    axios.post(`${API}/interest/physical`, { choice: c, source }).catch(() => {});
  };

  const btnSize = compact ? "!py-3 !px-6 !text-[14px]" : "";

  return (
    <div data-testid={`physical-interest-${source}`}>
      {!choice && (
        <div className="flex flex-col sm:flex-row gap-3">
          <button className={`btn-primary ${btnSize}`} onClick={() => vote("ja")} data-testid={`interest-yes-${source}`}>
            {yesLabel}
          </button>
          <button className={`btn-ghost ${btnSize}`} onClick={() => vote("digital")} data-testid={`interest-no-${source}`}>
            Digital reicht mir
          </button>
        </div>
      )}
      <AnimatePresence>
        {choice === "ja" && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`interest-email-block-${source}`}
          >
            <p className={`font-medium ${compact ? "text-sm" : "text-[15px]"} mb-4`}>
              Möchtest du Bescheid bekommen, sobald es Neuigkeiten gibt?
            </p>
            <WaitlistForm listType="ringbuch" cta="Zur Interessentenliste hinzufügen" testPrefix={`interest-${source}`} />
            <p className="text-xs text-[color:var(--ink-muted)] mt-3">
              Kein Spam. Du erhältst nur Informationen zur physischen VisualMA-Version.
            </p>
          </motion.div>
        )}
        {choice === "digital" && (
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`interest-thanks-${source}`}
          >
            <p className="font-display italic text-lg">Alles klar – danke für deine Rückmeldung!</p>
            <p className="text-sm text-[color:var(--ink-muted)] mt-1.5">
              Die digitale Lernwelt bleibt natürlich jederzeit für dich da.
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
